<div class="workflow-main">
  <div class="workflow-main-container">
    <div class="channel w-100" *ngFor="let header of workflowHeaders; index as index; last as isLast">
      <div class="channel-header">
        <div class="sm-pl-2">
          <strong>{{ header.title }}</strong>
          <small *ngIf="channels[index].totalFormsCount" class="text-muted"
            >({{ channels[index].totalFormsCount }})</small
          >
        </div>
        <cc-workflow-notification-list-dropdown
          [options]="teamUsers"
          [template]="template"
          [index]="index"
          [placement]="isLast ? 'left' : 'bottom-right'"
          (handleNotificationListClick)="handleNotificationListClick()"
          [canEditNotificationList]="canEditNotificationList"
          (change)="updateNotificationList($event)"
        >
        </cc-workflow-notification-list-dropdown>
      </div>
      <cc-workflow-column
        *ngIf="workflowColumnVisible"
        [columnNumber]="index"
        [template]="template"
      ></cc-workflow-column>
    </div>
    <div *ngIf="!hasForms && !loading" class="workflow-empty-state">
      <h3 class="h3" i18n>No forms have been created</h3>
      <h5 class="h5" *ngIf="canAddForm" i18n>Click the green button on the right to get started.</h5>
    </div>
    <div *ngIf="!hasForms && !loading && canAddForm" class="empty-state-arrow">
      <i class="fa fa-arrow-up fa-2x text-success"></i>
    </div>
  </div>
</div>
